// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ____   ____    .__   __
 * \\   \\ /   /___ |  |_/  |______      ____ ___.__.
 *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |
 *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |
 *    \\___/ \\____/|____/__| (____  /\\___  // ____|
 *                               \\//_____/ \\/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

/* OpenLayers specific styles */
.ol-control {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  padding: 2px;
}

.ol-control button {
  display: block;
  margin: 1px;
  padding: 0;
  color: white;
  font-size: 1.14em;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  height: 1.375em;
  width: 1.375em;
  line-height: 0.4em;
  background-color: var(--primary-color);
  border: none;
  border-radius: 2px;
}

.ol-control button:hover,
.ol-control button:focus {
  background-color: var(--secondary-color);
}

.ol-zoom {
  pointer-events: auto;
  left: unset !important;
  top: unset !important;
  bottom: 2em;
  right: 0.5em;
  background-color: rgba(255, 255, 255, 0.8) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.dark .ol-zoom {
  background-color: rgba(31, 41, 55, 0.8) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.ol-zoom button {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

.dark .ol-zoom button {
  color: white !important;
  background-color: rgba(31, 41, 55, 0.8) !important;
}

.ol-rotate {
  top: 4em !important;
  right: 0.5em;
}

.ol-attribution {
  font-size: 12px;
}

.ol-tooltip {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  font-size: 12px;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}

.ol-tooltip.dark {
  background: rgba(255, 255, 255, 0.5);
  color: black;
}

.ol-tooltip-measure {
  opacity: 1;
  font-weight: bold;
}

.ol-tooltip-static {
  background-color: #ffcc33;
  color: black;
  border: 1px solid white;
}

.ol-tooltip-measure.dark {
  background-color: #333;
  color: white;
}

.ol-tooltip-static.dark {
  background-color: #666;
  color: white;
  border: 1px solid #ccc;
}

.ol-tooltip-measure:before,
.ol-tooltip-static:before {
  border-top: 6px solid rgba(0, 0, 0, 0.5);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: "";
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}

.ol-tooltip-static:before {
  border-top-color: #ffcc33;
}

.ol-tooltip-measure.dark:before,
.ol-tooltip-static.dark:before {
  border-top-color: rgba(255, 255, 255, 0.5);
}

.ol-tooltip-static.dark:before {
  border-top-color: #666;
}

.ol-popup {
  position: absolute;
  padding: 1px;
  border-radius: 5px;
  bottom: 12px;
  left: -50px;
  min-width: 220px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.tool-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s ease-in-out;
}

.tool-switch:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.tool-switch-label {
  display: flex;
  align-items: center;
}

.tool-switch-icon {
  margin-right: 0.75rem;
}

.tool-switch-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.tool-switch-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.tool-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.tool-switch-slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .tool-switch-slider {
  background-color: #2196f3;
}

input:checked + .tool-switch-slider:before {
  transform: translateX(20px);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/map.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAEF,+BAA+B;AAC/B;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,wEAAwE;AAC1E;;AAEA;EACE,kDAAkD;EAClD,wEAAwE;AAC1E;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,wCAAwC;EACxC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/*\n * ____   ____    .__   __\n * \\   \\ /   /___ |  |_/  |______      ____ ___.__.\n *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |\n *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |\n *    \\___/ \\____/|____/__| (____  /\\___  // ____|\n *                               \\//_____/ \\/\n *\n * Copyright (c) 2017-2025 Voltagy. All rights reserved.\n * https://voltagy.com\n *\n * PROPRIETARY AND CONFIDENTIAL\n *\n * This source code is the proprietary and confidential property of Voltagy.\n * Unauthorized copying, transfer, or use of this file, via any medium, is\n * strictly prohibited without the express written permission of Voltagy.\n *\n * The receipt or possession of this source code and/or related information\n * does not convey or imply any right to use it, reproduce it, disclose its\n * contents, or to manufacture, use, or sell anything that it may describe.\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE\n * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE\n * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\n * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF\n * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS\n * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN\n * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)\n * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE\n * POSSIBILITY OF SUCH DAMAGE.\n *\n */\n\n/* OpenLayers specific styles */\n.ol-control {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.ol-control button {\n  display: block;\n  margin: 1px;\n  padding: 0;\n  color: white;\n  font-size: 1.14em;\n  font-weight: bold;\n  text-decoration: none;\n  text-align: center;\n  height: 1.375em;\n  width: 1.375em;\n  line-height: 0.4em;\n  background-color: var(--primary-color);\n  border: none;\n  border-radius: 2px;\n}\n\n.ol-control button:hover,\n.ol-control button:focus {\n  background-color: var(--secondary-color);\n}\n\n.ol-zoom {\n  pointer-events: auto;\n  left: unset !important;\n  top: unset !important;\n  bottom: 2em;\n  right: 0.5em;\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n.dark .ol-zoom {\n  background-color: rgba(31, 41, 55, 0.8) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n.ol-zoom button {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n\n.dark .ol-zoom button {\n  color: white !important;\n  background-color: rgba(31, 41, 55, 0.8) !important;\n}\n\n.ol-rotate {\n  top: 4em !important;\n  right: 0.5em;\n}\n\n.ol-attribution {\n  font-size: 12px;\n}\n\n.ol-tooltip {\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  color: white;\n  padding: 4px 8px;\n  opacity: 0.7;\n  white-space: nowrap;\n  font-size: 12px;\n  cursor: default;\n  user-select: none;\n}\n\n.ol-tooltip.dark {\n  background: rgba(255, 255, 255, 0.5);\n  color: black;\n}\n\n.ol-tooltip-measure {\n  opacity: 1;\n  font-weight: bold;\n}\n\n.ol-tooltip-static {\n  background-color: #ffcc33;\n  color: black;\n  border: 1px solid white;\n}\n\n.ol-tooltip-measure.dark {\n  background-color: #333;\n  color: white;\n}\n\n.ol-tooltip-static.dark {\n  background-color: #666;\n  color: white;\n  border: 1px solid #ccc;\n}\n\n.ol-tooltip-measure:before,\n.ol-tooltip-static:before {\n  border-top: 6px solid rgba(0, 0, 0, 0.5);\n  border-right: 6px solid transparent;\n  border-left: 6px solid transparent;\n  content: \"\";\n  position: absolute;\n  bottom: -6px;\n  margin-left: -7px;\n  left: 50%;\n}\n\n.ol-tooltip-static:before {\n  border-top-color: #ffcc33;\n}\n\n.ol-tooltip-measure.dark:before,\n.ol-tooltip-static.dark:before {\n  border-top-color: rgba(255, 255, 255, 0.5);\n}\n\n.ol-tooltip-static.dark:before {\n  border-top-color: #666;\n}\n\n.ol-popup {\n  position: absolute;\n  padding: 1px;\n  border-radius: 5px;\n  bottom: 12px;\n  left: -50px;\n  min-width: 220px;\n}\n\n.ol-popup:after,\n.ol-popup:before {\n  top: 100%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.ol-popup:after {\n  border-width: 10px;\n  left: 48px;\n  margin-left: -10px;\n}\n\n.ol-popup:before {\n  border-width: 11px;\n  left: 48px;\n  margin-left: -11px;\n}\n\n.tool-switch {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.tool-switch:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.tool-switch-label {\n  display: flex;\n  align-items: center;\n}\n\n.tool-switch-icon {\n  margin-right: 0.75rem;\n}\n\n.tool-switch-toggle {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.tool-switch-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.tool-switch-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n\n.tool-switch-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .tool-switch-slider {\n  background-color: #2196f3;\n}\n\ninput:checked + .tool-switch-slider:before {\n  transform: translateX(20px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
